export default {
	// Config
	apiKey: "AIzaSyAjP-DC_6VO-7aBpnwOsKED0UAzarV__x0",
  authDomain: "dimehemp-mytrace.firebaseapp.com",
  projectId: "dimehemp-mytrace",
  storageBucket: "dimehemp-mytrace.firebasestorage.app",
  messagingSenderId: "799455706656",
  appId: "1:799455706656:web:05990215ab20c3b14c0645"
};
